import { render, staticRenderFns } from "./ReportedReviewListDialog.vue?vue&type=template&id=f2ac34d6"
import script from "./ReportedReviewListDialog.vue?vue&type=script&lang=js"
export * from "./ReportedReviewListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports